import React from "react"
import { Link, graphql } from "gatsby"
import IndexLayout from "../layouts"
import { format } from "date-fns"
import SEO, { SITE_NAME, SITE_URL } from "../components/SEO"
import { JsonLd } from "../components/JsonLd"

export const Head = ({ data, location }: any) => {
  const post = data.markdownRemark
  const title = `${post.frontmatter.title} - Full Stack Craft Blog`
  const description = post.frontmatter.description || post.excerpt
  const url = `${SITE_URL}${location.pathname}`
  const blogPostingSchema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.frontmatter.title,
    description,
    url,
    datePublished: post.frontmatter.date,
    dateModified: post.frontmatter.date,
    author: {
      "@type": "Person",
      name: post.frontmatter.author || "Chris",
    },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      url: SITE_URL,
      logo: {
        "@type": "ImageObject",
        url: `${SITE_URL}/og.png`,
      },
    },
  }

  return (
    <>
      <SEO
        pathname={location.pathname}
        title={title}
        description={description}
        ogType="article"
      />
      <JsonLd schema={blogPostingSchema} />
    </>
  )
}

const BlogPostTemplate = ({ data, pageContext }: any) => {
  const post = data.markdownRemark
  const { previous, next } = pageContext

  return (
    <IndexLayout>
      <article className="container my-5 py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-7">
            <h1 className="mt-3">{post.frontmatter.title}</h1>
            <h2 className="fs-2 text-muted">{post.frontmatter.description}</h2>
            <p className="fs-6 mb-5 text-muted">
              <i>
                Written by Chris on{" "}
                {format(post.frontmatter.date, "MMMM do, yyyy")}
              </i>
            </p>
            <section
              className="blog"
              dangerouslySetInnerHTML={{ __html: post.html }}
            />
            {(previous || next) && (
              <>
                <h3 style={{ paddingTop: `3rem`, paddingBottom: `1rem` }}>
                  More posts:
                </h3>
                <nav>
                  <ul
                    className="d-flex flex-column justify-content-between align-items-center flex-wrap fs-3 my-5"
                    style={{
                      listStyle: `none`,
                    }}
                  >
                    <li className="my-3" style={{ listStyleType: "none" }}>
                      {previous && (
                        <Link to={previous.fields.slug} rel="prev">
                          ← {previous.frontmatter.title}
                        </Link>
                      )}
                    </li>
                    <li className="my-3" style={{ listStyleType: "none" }}>
                      {next && (
                        <Link to={next.fields.slug} rel="next">
                          {next.frontmatter.title} →
                        </Link>
                      )}
                    </li>
                  </ul>
                </nav>
              </>
            )}
          </div>
        </div>
      </article>
    </IndexLayout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        author
        description
        date(formatString: "MMMM DD, YYYY")
      }
    }
  }
`
